// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__34be4","header":"PatientQuestionnaire_header__Xbp7A","info":"PatientQuestionnaire_info__2LWKy"};